import { gql } from '@apollo/client';
import {
  AgentActivityLog,
  AgentActivityLogDocumentType,
  AgentActivityLogOutcome,
  AgentActivityLogProcessType,
} from '@trnsact/trnsact-shared-types';

export const GET_AGENT_ACTIVITY = gql`
  query GetAgentActivity($input: GetAgentActivityInput!) {
    getAgentActivity(input: $input) {
      agentActivityLogId
      agentExecutionId
      documentType
      processType
      trigger
      payload
      error
      associations
      outcome
      reviewRequired
      reviewReasons
      createdDateTime
      review {
        status
        fieldEdits
        reviewedBy
        reviewedByName
        reviewedDateTime
        opportunityCreated
        vendorOpportunityId
        creditSubmissionId
      }
    }
  }
`;

export interface GetAgentActivityResponse {
  getAgentActivity: AgentActivityLog[] | null;
}

export { AgentActivityLogDocumentType };

export interface GetAgentActivityInput {
  from: string;
  to: string;
  outcome?: AgentActivityLogOutcome | null;
  processType?: AgentActivityLogProcessType | null;
}
